import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_VANTIVE_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_VANTIVE,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_VANTIVE_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_VANTIVE_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_VANTIVE_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  VANTIVE_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  VANTIVE_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_VANTIVE,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  VANTIVE_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_VANTIVE,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

//START

translations[APP_TITLE] = "제품 피드백 포털";
translations[LANDING_BRIEF] = "Vantive  제품 피드백 포털 시스템은 Vantive 제품에 대한 기밀 정보 및 피드백을 제출하기 위한 곳입니다.";
translations[LANDING_LANGUAGE_SELECTOR] = "선호하는 언어를 선택해주세요.";
translations[LANDING_COUNTRY_SELECTOR] = "이벤트가 발생한 국가를 선택해주세요.";
translations[LANDING_TERMS] = "제품 피드백 포털에 대한 사용 약관 및 개인 정보 보호 정책을 읽고 이에 동의합니다.";
translations[LANDING_TERMS_ERROR] = "당신은 제품 피드백 포털 시스템에 대한 사용 약관 및 개인 정보 보호 정책 그리고 제품 피드백 포털 시스템 추가 사용 약관 및 개인 정보 보호 정책의 내용을 읽고 동의해야 합니다.";
translations[LANDING_CAPTCHA_ERROR] = "사용자가 로봇이 아님을 확인하십시오.";
translations[APP_DESCRIPTION] = "Vantive제품 피드백 포털을 통해 제품에 대한 정보를 제출할 수 있습니다. Vantive 제품에서 문제가 발생한 경우, 해당 이벤트에 대한 세부 정보를 공유해 주십시오. 제품과 제품에 대한 만족도를 지속적으로 개선하기 위한 우리의 목표를 달성하기 위해서는 여러분의 피드백이 반드시 필요합니다.";
translations[LANDING_TERMS_I_HAVE_READ] = "Vantive 제품 피드백 포털에 대한 링크된 개인 정보 보호 고지를 읽었으며 Vantive Healthcare Corporation('Vantive')이 개인 정보 보호 고지에 설명된 목적을 위해 내 개인 데이터를 사용, 공개 및 처리하는 데 동의를 구하고 있음을 이해합니다. 본인은 이에 동의합니다.";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "개인 정보 보호 고지에 설명된 목적을 위한 내 개인 데이터(내가 제공하기로 선택한 건강 관련 데이터와 같은 민감한 데이터 포함)의 사용, 공개, 저장 및 처리.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "내 개인 데이터(내가 제공하기로 선택한 건강 관련 데이터와 같은 민감한 데이터 포함)를 다른 국가와 법이 덜 엄격하거나 데이터 보호법이 없는 다른 국가로 이전하는 것.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "나는 이 동의가 자발적이며 언제든지 마음을 바꿀 수 있으며 개인 정보 보호 고지에 제공된 연락처 세부 정보를 사용하여 Vantive에 연락하여 동의를 철회할 수 있음을 이해합니다. 본인은 동의 철회가 철회 전 처리의 적법성에 영향을 미치지 않는다는 점을 이해합니다.";
translations[MENU_FEEDBACK_FORM] = "제품 피드백 시작";
translations[MENU_FEEDBACK_STATUS] = "제품 피드백 상태 확인";
translations[MENU_FORM_INTAKE] = "최초 보고자 정보";
translations[MENU_FORM_EVENT_DETAILS] = "이벤트 상세정보";
translations[MENU_FORM_PRODUCT_INFO] = "제품 정보";
translations[SYSTEM_FEEDBACK_FORM] = "제품 피드백 양식 작성";
translations[SYSTEM_FEEDBACK_STATUS] = "제품 피드백 상태 확인";
translations[SUBMIT_FEEDBACK] = "피드백을 제출하려면 여기를 클릭하십시오.";
translations[CHECK_SUBMITTED_FEEDBACK] = "이전에 제출한 피드백 상태를 확인하려면 여기를 클릭하십시오.";
translations[BTN_LAUNCH_FORM] = "양식 작성";
translations[BTN_CHECK_STATUS] = "상태 확인";
translations[FORM_TITLE] = "제품 피드백 폼";
translations[FORM_SUB_TITLE] = "환자가 여러 명일 경우 환자별로 양식을 작성해 주십시오.";
translations[FORM_MANDATORY_FIELDS] = "*가 있는 모든 필드는 필수 항목입니다.";
translations[BUTTON_PREV] = "이전";
translations[BUTTON_NEXT] = "다음";
translations[BUTTON_SUBMIT] = "제출";
translations[SELECT_RESPONSE] = "응답선택";
translations[FUNCTION_ROLE] = "부서/직급";
translations[CUSTOMER_ACCOUNT_NUMBER] = "고객 번호";
translations[ENTER_CUSTOMER_ACCOUNT] = "고객 계정 입력";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "보고된 이벤트에 관련된 고객의 고유 번호는 무엇입니까?";
translations[EVENT_REPORTED] = "이 이벤트는 사전에 Vantive 또는 다른 기관에 보고된 바 있습니까?";
translations[REFERENCE_NUMBER] = "이 이벤트와 관련된 참조 번호";
translations[ENTER_REFERENCE] = "참조 입력";
translations[WHO_REPORTED_TO] = "이벤트가 누구에게 보고되었습니까?";
translations[WHO_WAS_NOTIFIED] = "보고받은 사람의 이름은 무엇인가요?";
translations[ENTER_NAME] = "이름 입력";
translations[YOUR_NAME] = "당신의 이름";
translations[OCCUPATION] = "직업";
translations[PHONE_NUMBER] = "전화번호";
translations[ENTER_PHONE_NUMBER] = "전화번호 입력";
translations[ENTER_EMAIL] = "이메일 입력";
translations[EMAIL_ADDRESS] = "이메일주소";
translations[ENTER_ADDRESS] = "이메일 주소 입력";
translations[ENTER_NA_IF_UNKNOWN] = "알 수 없는 경우 NA 를 입력하세요";
translations[FACILITY_HOSPITAL] = "병원명 또는 회사명(해당되는 경우)";
translations[ENTER_FACILITY] = "시설 입력";
translations[ADDRESS_1] = "주소1";
translations[ADDRESS_2] = "주소2";
translations[CITY] = "도시";
translations[STATE] = "주";
translations[POSTAL_CODE] = "우편번호";
translations[COUNTRY] = "국가";
translations[END_USER_CUSTOMER] = "최종 사용자/고객이 이 문제를 발견했습니까?";
translations[ADDITIONAL_CONTACT_PERSON] = "추가 담당자";
translations[ADDITIONAL_PHONE] = "추가 연락처";
translations[ADDITIONAL_EMAIL] = "추가 이메일 주소";
translations[ANOTHER_FACILITY_ADDRESS] = "다른 시설/주소 추가";
translations[ANOTHER_FACILITY_HOSPITAL] = "다른 병원 또는 회사면(해당되는 경우)";
translations[ANOTHER_ENTER_FACILITY] = "시설 입력";
translations[ANOTHER_ADDRESS_1] = "주소1";
translations[ANOTHER_ADDRESS_2] = "주소2";
translations[ANOTHER_CITY] = "도시";
translations[ANOTHER_STATE] = "주";
translations[ANOTHER_POSTAL_CODE] = "우편번호";
translations[ANOTHER_COUNTRY] = "국가";
translations[LOT_SERIAL_NUMBER] = "제조번호/시리얼 넘버";
translations[ENTER_LOT_SERIAL_NUMBER] = "제조번호/시리얼 번호 입력";
translations[HELP_LOT_SERIAL_NUMBER] = "Lot / Serial Number를 모르는 경우, 또는 보고자에게 문의했는데 모르는 경우 'Unknown'을 선택합니다.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "제품 코드";
translations[PRODUCT_CODE] = "제품 코드";
translations[ENTER_PRODUCT_CODE] = "제품코드 입력";
translations[HELP_PRODUCT_CODE] = "Product Code를 모르는 경우,또는 보고자에게 문의했는데 모르는 경우 'Unknown'을 선택합니다.";
translations[NDC] = "국가 의약품 코드(NDC) 번호";
translations[ENTER_NDC] = "국가 의약품 코드(NDC) 번호 입력";
translations[UDI] = "고유 장비 식별 번호 (UDI)";
translations[ENTER_UDI] = "UDI입력";
translations[PRODUCT_NAME] = "제품명";
translations[ENTER_PRODUCT_NAME] = "제품명 입력";
translations[HELP_PRODUCT_NAME] = "제품 이름 또는 제품 설명을 제공해주세요";
translations[BEST_DESCRIBES] = "보고된 문제를 가장 잘 설명하는 항목을 선택하십시오.";
translations[QUANTITY_TO_SELECT] = "수량";
translations[ENTER_QUANTITY] = "수량 입력";
translations[HELP_QUANTITY] = "보고된 문제가 발생한 제품 수량";
translations[UNIT] = "단위";
translations[AVAILABLE_TO_RETURNED] = "문제가 보고된 실제 제품은 평가를 위해 Vantive로 반송이 가능합니까?";
translations[PHOTOGRAPH_AVAILABLE] = "제품의 사진이나 비디오가 있습니까?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "보고된 문제가 사진이나 비디오에 명확하게 나타나는지 확인합니다.";
translations[UPLOAD_IMAGES] = "사진은 업로드 하세요";
translations[REPORTER_NAME] = "최초 보고자 이름";
translations[REPORTER_FACILITY] = "최초 보고자 직장";
translations[REPORTER_OCCUPATION] = "최초 보고자 직업";
translations[ENTER_NUMBER] = "숫자 입력";
translations[REPORTER_PHONE_NUMBER] = "최초 보고자 연락처";
translations[REPORTER_EMAIL_ADDRESS] = "최초 보고자 이메일 주소";
translations[EMPLOYEE_NAME] = "직원 이름";
translations[EMPLOYEE_PHONE_NUMBER] = "직원 전화번호";
translations[EMPLOYEE_EMAIL_ADDRESS] = "직원 이메일 주소";
translations[RETURNING_FOR_INVESTIGATION] = "보고된 문제가 있는 샘플 몇 개를 조사하기 위해 반송합니까?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "이 샘플들은 보고된 문제가 있는 제품일 것입니다.";
translations[UNUSED_VANTIVE_PRODUCT] = "동일한 로트의 사용하지 않은 Vantive 제품이 평가를 위해 Vantive로 반송될 수 있습니까?";
translations[YOU_INDICATED_SAMPLES] = "샘플이 평가에 사용 가능하다고 하셨는데, 의료 기관에 가져다 주실 수 있나요?";
translations[SAMPLE_RETURN_KIT] = "샘플을 평가할 수 있다고 하셨습니다. 샘플 반품 키트를 보낼 주소를 확인하십시오.";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "샘플을 반환하기 위해 라벨이 있는 상자가 이 주소로 발송됩니다.";
translations[SAME_AS_MY_ADDRESS] = "내 주소와 동일";
translations[OTHER_CONTACT_NAME] = "추가 연락받을 사람 이름";
translations[OTHER_CONTACT_OCCUPATION] = "추가 연락받을 사람 직업";
translations[OTHER_CONTACT_PHONE_NUMBER] = "추가 연락받을 사람 전화번호";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "추가 연락받을 사람 이메일 주소";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "선택한 제품이 다른 회사에서 제조한 제품일 경우, 보고서에 대한 추가 질문이 있으면 해당 업체에 당신의 연락처를 제공해도 됩니까?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "고객이 조사 결과를 요청했습니까?";
translations[EXPLICITLY_REQUEST_CREDIT] = "고객이 교품을 요청했습니까?";
translations[PRODUCT_FROM_VANTIVE] = "고객이 Vantive에서 직접 제품을 주문하나요?";
translations[QUANTITY_REQUESTED_CREDIT] = "교품을 위해 요청된 로트 번호 및 수량:";
translations[ENTER_OCCUPATION] = "직업 입력";
translations[LOT_QUANTITY_NUMBER] = "제조번호와 수량 입력";
translations[WHOLESALERS_NAME] = "는 무엇입니까도매상 이름 및 위치(도시)";
translations[PLACE_WHOLESALERS_NAME] = "도매상 이름 및 위치(도시)";
translations[ADD_PRODUCT_TO_THE_GRID] = "표에 제품 추가";
translations[SAVE] = "저장";
translations[CANCEL] = "취소";
translations[ADD_MORE_PRODUCTS] = "추가 제품이 있나요?";
translations[REPORTER_ADDRESS] = "최초 보고자 주소";
translations[ATTACHMENTS] = "첨부";
translations[DATE_OF_EVENT] = "이슈 발생일";
translations[DATE_OF_EVENT_MSG] = "사건발생일은 Vantive 직원이 처음 보고받은 날짜 이후일 수 없습니다. 유효한 날짜를 입력하십시오.";
translations[HELP_DATE_OF_EVENT] = "이벤트가 발생한 것으로 알려진 날짜가 여러 개 있는 경우 각 날짜에 대한 양식을 작성하십시오.";
translations[DATE_VANTIVE_EMPLOYEE] = "Vantive의 직원이 최초로 연락받은 날짜";
translations[DURING_WHAT_PROCESS] = "어떤 프로세스 단계에서 이벤트가 발생하였나요?";
translations[WAS_THE_PATIENT] = "환자가 사건 발생 당시 치료중이였습니까?";
translations[WERE_YOU_CONNECTED] = "사건 당시 (치료 진행 중) 당신은 제품에 연결이 되어 있었습니까?";
translations[PROVIDE_ANY_ADDITIONAL] = "이벤트/이슈와 관련된 추가 세부 정보를 제공해주세요";
translations[HELP_YOU_IDENTIFIED_MORE] = "두 개 이상의 제품과 문제를 확인했습니다. 문제가 보고된 제품이 무엇인지 명확히 해 주십시오.";
translations[ENTER_DETAILS] = "세부정보 입력";
translations[PROVIDE_ANY_ATTACHMENT] = "가능하다면 첨부 파일을 제공해 주세요";
translations[WAS_NEGATIVE_MEDICAL] = "해당 이벤트로 인해 부정적인 의학적 영향, 환자 증상 또는 부상이 있었습니까?";
translations[WAS_MEDICAL_INTERVENTION] = "보고된 사건으로 인하여 치료, 의료 개입 또는 추가 관리가 제공되었나요?";
translations[PROVIDE_DETAILS] = "세부 정보를 제공해 주세요";
translations[REQUIRED_TREATMENT] = "필요한 치료/의료 개입";
translations[ENTER_TREATMENT] = "치료 입력";
translations[RELEVANT_TESTS] = "실험실 데이터를 포함한 관련 시험";
translations[HELP_RELEVANT_TESTS] = "관련 테스트 입력";
translations[RELEVANT_MEDICAL_HISTORY] = "기존 의료 상태를 포함한 관련 의료 기록";
translations[ENTER_HISTORY] = "히스토리 입력";
translations[PATIENT_NAME] = "환자 이름";
translations[PATIENT_INITIALS] = "환자의 이니셜 또는 전체 이름. 환자가 여러 명일 경우 환자별로 양식을 작성해 주십시오.";
translations[PATIENT_PHONE_NUMBER] = "환자 전화번호";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "저는 정보를 제공하고 싶지 않습니다.";
translations[PATIENT_EMAIL_ADDRESS] = "환자 이메일 주소";
translations[PATIENT_ADDRESS] = "환자 주소";
translations[SAME_ADDRESS] = "동일한 주소";
translations[DRUG_BEING_USED] = "이벤트 당시 Vantive 의약품이 사용되었습니까?";
translations[PATIENT_IDENTIFIER] = "환자 식별";
translations[PATIENT_AGE_OR_DOB] = "환자 연령 또는 생년월일";
translations[ENTER_PATIENT_AGE] = "mm/dd/yyyy, 환자 나이 입력";
translations[PATIENT_GENDER] = "환자 성별";
translations[PATIENT_WEIGHT] = "환자 체중";
translations[ENTER_WEIGHT] = "체중 입력";
translations[PATIENT_WEIGHT_UNIT] = "환자 체중 단위";
translations[MY_NAME] = "이름";
translations[ENTER_IN_YOUR_CONTACT] = "당신의 연락처 정보를 입력하십시오.";
translations[MY_PHONE_NUMBER] = "전화번호";
translations[MY_EMAIL_ADDRESS] = "이메일 주소";
translations[MY_ADDRESS] = "주소";
translations[NAME_OF_VANTIVE_DRUG] = "Vantive 의약품 제품이름 ";
translations[ENTER_DRUG_NAME] = "의약품 정보 입력";
translations[PLEASE_PROVIDE_THE_NAME] = "Vantive 의약품의  제품이름 또는 제품 코드를 제공하십시오. 문제가 보고된 시점에 사용 된 모든 Vantive 의약품의 이름을 제공해주십시오. ";
translations[SELECT_THE_COMPONENT] = "이슈가 발생한 구성 요소를 선택하십시오.";
translations[USE_THE_DIAGRAM] = "위의 다이어그램(그림 1)을 사용하여 손상된 제품의 위치를 확인합니다.";
translations[TYPE_OF_DAMAGE] = "손상 유형을 설명하십시오.";
translations[PLEASE_ENTER_VALUE] = "값을 입력하십시오";
translations[WAS_THE_PRODUCT_KINKED] = "제품이 꼬이거나, 금이 가거나, 구부러지거나, 잘린 상태였습니까?";
translations[WERE_ANY_CLEANING] = "제품에 세척액, 용제 또는 소독제가 사용되었습니까?";
translations[WHAT_WAS_THE_DISINFECTANT] = "소독제 이름/브랜드가 무엇이었고 어떻게 사용되었습니까?";
translations[NOTE_VANTIVE_LABELING] = "Vantive 라벨은 알코올이 포함된 표백제, 과산화수소, 알코올 또는 소독제를 세트에 적용하지 않도록 명시되어 있습니다. 이러한 제품을 사용하면 제품에 균열이 생길 수 있습니다.";
translations[SELECT_ALL_THAT_APPLY] = "해당되는 항목을 모두 선택하십시오.";
translations[DID_FOLLOWING_OCCUR] = "다음 중 하나라도 발생했습니까?";
translations[SELECT_THE_LOCATION] = "미니 캡에 손상이 있는 위치를 선택하십시오.";
translations[WAS_THE_PRODUCT_EXPOSED] = "문제가 발생하기 전에 제품이 과도한 충격(즉, 부딪힘)에 노출되었습니까?";
translations[HOW_LONG_TRANSFER] = "트랜스퍼 세트를 사용한 지 얼마나 되었습니까?";
translations[WAS_THERE_DIFFICULTY] = "트위스트 클램프를 열거나 닫을 때 어려움은 없었습니까?";
translations[WAS_DEVICE_OR_TOOL] = "트위스트 클램프를 열거나 닫을 때 장치 또는 공구를 사용했습니까?";
translations[DESCRIBE_HOW_PRODUCT] = "제품을 어떻게 사용하기 어려웠는지 설명하십시오(해당하는 항목을 모두 선택하십시오).";
translations[DID_YOU_OBSERVE] = "제품에 손상(절단, 구멍, 균열 등)이 있었습니까?";
translations[WERE_DIFFICULTIES_PUTTING] = "미니 캡을 트랜스퍼 세트에 장착하고 단단히 고정될 때까지 시계 방향으로 돌리는데 어려움이 없었습니까?";
translations[WAS_THE_TRANSFER] = "이 이슈로 인하여 세트가 교체되었나요?";
translations[SELECT_TYPE_OF_FLOW] = "흐름 이슈 유형 선택";
translations[WAS_ANYTHING_BLOCKING] = "흐름을 막는 장애물이 있었나요?";
translations[WAS_ANY_ALARM] = "알람이 울렸나요?";
translations[SELECT_BEST_DESCRIBE] = "문제를 가장 잘 설명하는 옵션을 선택하십시오.";
translations[WERE_THE_MINICAPS] = "미니캡이 고온/저온 환경에 노출되거나 보관되었습니까?";
translations[WAS_THE_SPONGE_VISIBLE] = "미니캡 안에서 스펀지가 보였나요?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "미립자 물질/이물질은 어디에 위치합니까?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "입자상 물질/이물질의 정확한 위치, 크기, 형태 및 색상 설명:";
translations[WAS_THE_PARTICULATE_MATTER] = "미립자/이물질이 제품에 내장되어 있습니까?";
translations[DOES_THE_PARTICULATE_MATER] = "미립자 물질/이물질이 제품을 구성하는 물질의 조각으로 보이나요?";
translations[WHAT_COMPONENT_DOES] = "미립자는 어떤 구성 요소에서 나온 것으로 보이나요?";
translations[SELECT_CONNECTION_ISSUE] = "연결 문제를 가장 잘 설명하는 옵션을 선택하십시오.";
translations[WERE_ASSIST_DEVICES] = "제품 연결을 위해 보조 장치 또는 도구가 사용되었습니까?";
translations[WERE_ANY_DIFFICULTIES] = "초기 연결 또는 분리 중에 문제가 발견되었습니까?";
translations[PROVIDE_PRODUCT_INFORMATION] = "연결 문제와 관련된 두 번째 제품의 제품 정보를 제공해주세요";
translations[WERE_THE_SPIKE_LUER] = "스파이크/루어 커넥터가 단단히 고정될 때까지 시계 방향으로 회전했습니까?";
translations[VANTIVE_LABELING_STATES] = "Vantive 라벨에는 치료를 시작하기 전에 모든 일회용 세트 연결이 안전하고 적합한지 확인하는 내용이 명시되어 있습니다.";
translations[WERE_PETS_OR_ANIMALS] = "세트에 손상을 줄 수 있는 애완동물이나 동물이 있었나요?";
translations[VANTIVE_LABELING_CONTAMINATION] = "Vantive 라벨은 애완동물이나 동물이 일회용 공급품을 물 경우 유체 경로의 오염이 발생할 수 있다고 명시되어 있습니다. 이러한 위험을 줄이기 위해 애완동물이나 동물과 같은 공간에서 투석을 진행하지 마십시오.";
translations[WERE_OTHER_ISSUES] = "스파이크/루어와 관련된 다른 문제나 어려움(즉, 균열, 변형, 구부러짐 등)이 있었습니까?";
translations[WAS_MINICAP_TWISTED] = "미니 캡이 단단히 고정될 때까지 트랜스퍼 세트 커넥터에서 시계 방향으로 돌았습니까?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "미니 캡을 트랜스퍼 세트에 장착하는 데 어려움이 없었습니까?";
translations[DID_TRANSFER_SET_CONNECTORS] = "트랜스퍼 세트 커넥터 나사산에 육안으로 확인되는 손상이나 잔류물이 있었습니까?";
translations[WHAT_WAS_THE_ALARM] = "어떤 알람이 울렸습니까?";
translations[WHERE_OBSERVED_DAMAGE] = "어디에서 손상이 관찰되었습니까(해당되는 모든 항목을 선택하십시오).";
translations[SELECT_THE_TYPE_OBSERVED] = "관찰된 손상의 유형을 선택합니다(해당되는 모든 유형 선택).";
translations[DID_DAMAGE_CAUSE_LEAK] = "손상으로 인하여 누출이 있었나요?";
translations[WAS_THE_SHIPPING_CARTON] = "배송 상자를 날카로운 도구로 열었습니까?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "관찰된 흐름 문제의 유형을 선택하십시오.";
translations[HOW_LONG_WAS_STORAGE] = "유효기한이 지난 제품이 발견되기까지 얼마나 오래 보관되어 있었습니까?";
translations[WAS_THERE_AN_ADAPTER] = "제품과 함께 사용된 어댑터 또는 다른 장치가 있었습니까?";
translations[NAME_AND_MODEL] = "어댑터 또는 사용된 다른 장치의 이름과 모델은 무엇입니까?";
translations[NAME_VAPORIZER] = "기화기의 이름과 모델은 무엇입니까?";
translations[WAS_VIAL_INVERTED] = "용액을 바이알에 짜넣기 전에 첨부된 바이알이 뒤집어졌습니까?";
translations[WHAT_VIAL_USED] = "사용된 바이알의 제품 정보는 무엇입니까?";
translations[DRUG_NAME_MANUFACTURER] = "의약품명, 제조업체, 바이알 크기";
translations[WERE_BREAK_FRANGIBLE] = "앞뒤로 움직여서 frangible을 제대로 작동시킬 수 있었습니까?";
translations[WAS_ALARM_ASSOCIATED] = "흐름 없음과 관련된 경보가 있었습니까?";
translations[WHAT_PART_DISCOLORED] = "제품의 어떤 부분이 변색되었다고 보고되었나요? (해당 항목을 모두 선택)";
translations[DESCRIBE_DISCOLORATION] = "변색에 대해 설명합니다(색상, 빛깔 등).";
translations[HOW_PRODUCT_STORED] = "그 제품은 어떻게 보관되었습니까?";
translations[DOES_DISCOLORATION_APPEAR] = "변색이 불투명하고 뿌옇거나 흐리거나 원형/벌집 모양의 흔적이 있습니까?";
translations[WHICH_CHAMBER_DISCOLORED] = "백의 어느 챔버가 변색되었습니까?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "박리 씰 또는 챔버 간 frangible 부분이 이미 파손/활성화되었습니까?";
translations[WAS_DISCOLORATION_NOTICED] = "기화기 투사 유리를 통해 변색이 감지되었습니까?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "문제를 보다 구체적으로 설명하는 옵션을 선택하십시오.";
translations[WHAT_DEVICE_HAD_ALARM] = "어떤 장치에서 경보가 울렸습니까?";
translations[WHAT_MISSING_MISASSEMBLED] = "누락되거나 잘못 조립된 구성 요소는 무엇입니까?";
translations[RECONSTITUTION_ISSUE] = "재구성 문제에 대한 보다 구체적인 설명을 제공해주세요";
translations[WHAT_MEDICATION_SOLUTION] = "어떤 의약품/용액으로 제품을 재구성하고 있었습니까?";
translations[WHAT_VOLUME_MEDICATION] = "재구성을 위해 사용된 의약품/솔루션의 양은 얼마였습니까?";
translations[WHAT_DEVICES_RECONSTITUTION] = "재구성 중에 사용된 다른 장치(장비명/제조업체, 니들 크기/게이지 등)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "제품이 열에 노출되었습니까?";
translations[DESCRIBE_EXPOSURE] = "노출(온도, 기간 등)을 설명합니다.";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "솔루션을 활성화하기 위해 어떤 기술이 사용되었습니까?";
translations[WAS_DAMAGE_OBSERVED] = "활성화하기 전에 제품에 손상이 관찰되었습니까?";
translations[DESCRIBE_THE_DAMAGE] = "손상에 대해 설명해 주세요";
translations[APPROXIMATELY_SOLUTION_POWDER] = "대략 얼마나 많은 용액이나 파우더가 부족하거나 과다하게 채워졌습니까?";
translations[WAS_LEAK_OBSERVED] = "누출이 관찰되었습니까?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "제품의 어떤 구성 요소나 기능을 사용하기 어렵습니까?";
translations[HOW_WAS_DIFFICULT_USE] = "그 제품이 사용하기 어려웠던 이유는 무엇입니까?";
translations[WHERE_MATTER_FOREIGN] = "미립자 물질/이물질은 어디에 위치했습니까?";
translations[DOES_PARTICULATE_MATTER] = "미립자 물질/이물질이 제품 구성 물질로 보이나요?";
translations[DESCRIBE_EXACT_LOCATION] = "입자 물질/이물질의 정확한 위치, 색상, 크기, 형태 및 질감을 설명해주세요";
translations[WAS_MATTER_FOREIGN] = "미립자/이물질이 제품에 고착되어 있었습니까(자유로이 움직이지 않나요)?";
translations[WHEN_MATTER_FOREIGN] = "미립자 물질/이물질은 언제 관찰되었습니까?";
translations[PROVIDE_INFORMATION_MEDICATION] = "추가된 의약품에 대한 제품 정보를 제공합니다.";
translations[PRODUCT_NAME_CODE_NUMBER] = "제품명, 제품코드, 제조번호, 브랜드명";
translations[DESCRIBE_SPIKING] = "사용된 스파이킹 또는 재구성 기술을 설명합니다.";
translations[INCLUDE_NEEDLE] = "바늘 크기/게이지, 스파이크/피어싱 각도, 시도 횟수를 포함해주세요";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "어떤 administration 세트 또는 재구성 장치가 사용되었습니까?";
translations[INCLUDE_MANUFACTURER] = "제조업체, 제품명, 제품 코드, 제품 로트 포함해주세요";
translations[WAS_MEDICATION_ADDITIVE] = "의약품, 첨가제 또는 재구성 용액이 제품에 추가되었습니까?";
translations[WHAT_MEDICATION_ADDITIVE] = "어떤 약물, 첨가제 또는 재구성 용액이 첨가되었습니까?";
translations[WHAT_STATE_OF_PRODUCT] = "탁한 용액/침전물이 관찰되었을 때 제품의 상태는 어땠습니까?";
translations[AFTER_UNITS_SAT] = "제품이 실온에 도달한 후 흐림/침전물이 사라졌습니까?";
translations[DID_ATTEMPT_AGITATE] = "제품을 휘저었나요?";
translations[DID_PRECIPITATE_DISSOLVE] = "침전물이 녹았습니까?";
translations[WHAT_STORAGE_TEMPERATURE] = "제품 보관 온도와 조건은 어떠했습니까?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "온도, 위치, 오버파우치/상자 내부 또는 외부에 보관, VSC/중간 카톤, 개별 유닛 정보를 제공해 주세요";
translations[ARE_TEMPERATURE_LOGS] = "제품이 보관되어 있는 냉동고의 온도 기록을 작성하나요?";
translations[LOGS_CAN_BE_ATTACHED] = "제출 시점에 로그를 사용할 수 있는 경우 이 양식에 직접 첨부할 수 있습니다.";
translations[IS_THE_STORAGE_UNIT] = "저장 장치(냉동고 또는 냉장고)가 보정되고 온도가 제어됩니까?";
translations[HOW_PRODUCT_THAWED] = "제품이 어떻게 해동되었습니까?";
translations[WHAT_STORAGE_CONDITIONS] = "그 제품의 보관 상태는 어땠나요? (온도, 위치, 오버파우치 또는 박스의 내부/외부 보관)";
translations[WAS_ANY_DAMAGE] = "관찰된 제품 손상 또는 이슈가 있었습니까?";
translations[MORE_SPECIFIC_INFORMATION] = "보다 구체적인 정보를 제공해주세요";
translations[WHAT_PURPOSE_INDICATION] = "환자의 치료 목적은 무엇이었습니까?";
translations[WHAT_ROUTE_ADMINISTRATION] = "투여 경로는 무엇이었습니까?";
translations[WHAT_DATE_ADMINISTRATION] = "투여 날짜와 기간(지속시간)은 언제였습니까?";
translations[WHAT_DOSAGE_STRENGTH] = "환자에게 투여된 용량/강도는 얼마입니까?";
translations[WAS_RECENT_PRESCRIPTION] = "최근에 처방전이 바뀌었나요?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "제품의 보관/온도 세부 사항(냉장고/냉동고 보관 위치 등)은 어떻게 됩니까?";
translations[WERE_ANY_ADJUSTMENTS] = "투여하기 전에 용액이나 첨가물에 대한 조정이 있었습니까?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "문제에 대한 가장 적절한 설명을 선택하십시오.";
translations[SELECT_LABELING_ISSUE] = "라벨링 문제에 대한 가장 적절한 설명을 선택합니다.";
translations[WAS_CONNECTION_SECURE] = "연결부가 단단히 고정되고 완전히 조여졌나요?";
translations[WAS_EXPIRED_PRODUCT] = "유효기간이 지난 제품이 환자에게 투여되었습니까?";
translations[WAS_COMPONENT_DAMAGED] = "손상된 구성 요소가 있었습니까?";
translations[WERE_ABNORMALITIES_DAMAGE] = "제품에 이상/손상 징후가 있었습니까?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "주문번호가 어떻게 되나요?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "투여 날짜가 언제였습니까?";
translations[WHAT_WAS_EXPIRATION_DATE] = "제품의 유효기간이 언제였습니까?";
translations[DESCRIBE_WAS_INCORRECT] = "라벨에 부정확하거나 불완전하거나 누락되었거나 읽을 수 없는 것 또는 라벨이너무 유사한 것(다른 제품과)에 대해 설명하십시오.";
translations[WHAT_SCANNER_USED] = "어떤 유형의 스캐너가 사용되었습니까?";
translations[WAS_OVERPOUCH_POUCH] = "스캔하는 동안 제품이 여전히 오버파우치/파우치 안에 있었습니까?";
translations[WHAT_BACKGROUND_COLOR] = "스캔할 때 배경색은 무엇이었습니까?";
translations[DO_ALL_OF_THE_LABELS] = "모든 라벨(제품, 박스/상자, 배송/유통)이 동일한 제품 정보를 가지고 있습니까?";
translations[PRODUCT_INFORMATION] = "제품 정보";
translations[IS_A_BARCODE_SCANNER] = "당신의 시설에서는 바코드 스캐너를 사용하고 있습니까?";
translations[HOW_ARE_THESE_PRODUCTS] = "이 제품들은 시설에 어떻게 보관됩니까?";
translations[WHAT_INFORMATION_INCORRECTLY] = "스캔 시 잘못 표시된 정보는 무엇입니까?";
translations[WAS_THERE_LEAK] = "누출 또는 습기가 관찰되었습니까?";
translations[WHERE_LEAK_OBSERVED] = "어디에서 누출이 관찰되었습니까? 어떤 구성 요소가 관련되어 있나요?";
translations[WAS_FRANGIBLE_OBSERVED] = "frangible 부분이 파손되었습니까?";
translations[IS_MOISTURE_CLEAR] = "수분이 맑습니까?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "유통회사가 어디인가요?";
translations[WHAT_MANUFACTURER_MEDICATION] = "사용된 바이알의 제조업체, 의약품명 및 크기는 무엇입니까?";
translations[WHAT_GAUGE_NEEDLE] = "사용된 바늘의 게이지, 제조사, 뚫은 횟수가 어떻게 되나요?";
translations[WHAT_ADMINISTRATION_SET] = "어떤 administration set가 사용되었습니까?";
translations[WAS_DIFFICULTY_SPIKING] = "스파이킹하는데 어려움이 있었나요?";
translations[WERE_FOLLOWING_SCENARIOS] = "누출과 관련하여 다음 시나리오 중 하나가 발생했습니까?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "frangible에 손상 또는 결함이 관찰되었습니까?";
translations[WHAT_AMOUNT_PRESSURE] = "어느 정도의 압력이 얼마 동안 적용되었나요?";
translations[WAS_BAG_COMPLETELY] = "가방이 압력 커프 안에 완전히 올바르게 삽입되었습니까(한쪽 끝이 압력 커프 밖에 있었습니까)?";
translations[WHAT_MANUFACTURER_MODEL] = "압력 커프의 제조업체, 모델 및 크기는 어떻게 됩니까?";
translations[WHAT_PRESSURE_PRIOR] = "누출이 감지되기 전의 압력은 얼마입니까?";
translations[LIST_THE_VAPORIZER] = "기화기 제조업체 및 이름/모델 나열";
translations[APPROXIMATELY_HOW_MUCH] = "대략 어느 정도의 액체가 흘렀나요?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "병을 기화기에 넣기가 어려웠나요?";
translations[WERE_VISIBLE_DEFECTS] = "눈에 보이는 결함이 있었습니까?";
translations[SELECT_THE_OPTION] = "연결 문제를 가장 잘 설명하는 옵션을 선택하십시오.";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "연결 문제와 관련된 두 번째 제품의 제품 정보를 제공해주세요";
translations[WHICH_PART_SEPARATED] = "제품의 어느 부분이 분리되었습니까?";
translations[WHAT_COMPONENT_DISCOLORED] = "변색된 구성 요소는 무엇입니까?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "변색을 가장 잘 설명하는 옵션을 선택합니다.";
translations[WAS_THE_SET_DISCOLORED] = "포장에서 꺼냈을 때 세트가 변색되었나요?";
translations[DID_SET_CHANGE_COLOR] = "약물을 추가해서 세트 색이 바뀌었나요?";
translations[WHAT_MEDICATION_ADDED] = "변색 전에 어떤 약이 첨가되었습니까?";
translations[WHERE_MATERIAL_LOCATED] = "미립자 물질/이물질은 어디에 위치했습니까?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "미립자 물질/이물질(외관/색상/크기):";
translations[WAS_EMBEDDED_PLASTIC] = "미립자 물질/이물질이 느슨하거나 플라스틱에 박혀 있었습니까?";
translations[WAS_THERE_A_PRECIPITATE] = "예상치 못한 침전물/용액의 색상의 변화가 있었습니까?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "어떤 약물/용액이 세트를 통해 주입되었습니까?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "손상 부위 또는 영향을 받은 구성 요소(해당되는 모든 구성 요소 선택)";
translations[WHAT_DAMAGE_ISSUE] = "어떤 유형의 손상/문제가 관찰되었습니까(해당되는 모든 유형 선택)?";
translations[DID_ISSUE_RESULT] = "이 문제로 인해 누출이 발생했습니까?";
translations[WAS_PATIENT_CONNECTED] = "환자가 제품에 연결 상태였나요?";
translations[WAS_PRODUCT_REPLACED] = "그 제품이 새 제품으로 교체되었나요?";
translations[WHICH_SITUATION_BEST] = "분리/연결 문제를 가장 잘 설명하는 상황은 무엇입니까?";
translations[SELECT_MOST_LABELING_ISSUE] = "라벨링 문제에 대한 가장 적절한 설명을 선택합니다.";
translations[WHAT_INFORMATION_DISPLAYED] = "어떤 정보가 표시되었습니까?";
translations[WHAT_SCANNER_WAS_USED] = "어떤 유형의 스캐너가 사용되었습니까?";
translations[INCLUDE_THE_MODEL_NAME] = "모델명을 포함해 주세요";
translations[WAS_PRODUCT_ORDERED] = "제품이 Vantive나 다른 유통업체에서 직접 주문되어졌나요?";
translations[WHERE_LEAK_COMING] = "어디에서 누출이 발생하고 있습니까(해당되는 모든 항목을 선택하십시오).";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "누출과 관련하여 다음 시나리오 중 하나가 발생했습니까?";
translations[WAS_POWER_INJECTOR] = "제품이 파워 인젝터와 함께 사용되었습니까?";
translations[WHAT_INJECTOR_USED] = "어떤 파워 인젝터가 사용되었나요?";
translations[MANUFACTURER_NAME_CODE_LOT] = "제조자, 제품명, 제품코드, 제품로트";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "라벨에서 잘못되었거나, 불완전하거나, 누락되었거나, 읽을 수 없거나, 변경된 내용을 설명합니다.";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "분리된 두 번째 제품의 제품 정보 제공";
translations[WHICH_COMPONENTS_WERE_FOUND] = "균열 또는 파손이 발견된 구성 요소는 무엇입니까?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "절단, 구멍 또는 슬라이스가 있는 튜브의 정확한 위치를 설명합니다.";
translations[WAS_LEAK_ORIGINATING] = "누출이 주입 부위에서 발생했습니까?";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "분리/연결 문제와 관련된 두 번째 제품의 제품 정보 제공";
translations[WHICH_SPECIFIC_BONDED] = "분리되어 있는 것으로 확인된 특정 구성 요소가 무엇입니까?";
translations[WERE_VISIBLE_IRREGULARITIES] = "관련된 제품/구성 요소에 눈에 보이는 불규칙성/손상 등이 있었습니까?";
translations[WAS_SUCCESSFUL_CONNECTION] = "(제품을 교체할 필요 없이) 성공적인 연결 또는 분리가 이루어졌습니까?";
translations[WAS_TOOL_USED_ASSIST] = "연결/분리 문제를 해결하기 위해 보조 공구를 사용했습니까?";
translations[WERE_LUER_CONNECTIONS] = "사용하기 전에 모든 Luer 연결부가 단단히 고정되어 있는지 라벨에 적힌대로 확인했나요?";
translations[WAS_PRODUCT_SECURELY] = "제품을 분리하기 전에 다른 제품과 완전히 연결되어 있었나요?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "다음 중 흐름 문제를 가장 잘 설명한 상황은 무엇입니까?";
translations[WHAT_FLOWING_BACKWARDS] = "역류가 있었나요?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "역류가 시작된 곳에서 멈춘 곳까지의 구성 요소를 설명합니다.";
translations[DO_SITUATIONS_APPLY] = "이러한 상황 중 어느 것이 이 이벤트에 해당됩니까?";
translations[WHICH_SPECIFIC_AREA] = "흐름 문제와 관련된 세트 또는 구성 요소의 특정 부위는 어디인가요?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "이전에 세트 또는 구성 요소를 통해 흐름이 보였습니까?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "다음 중 하나가 관찰되었습니까?";
translations[WHERE_SIMULTANEOUS_FLOW] = "흐름이 있었던 곳은 어디인가요?";
translations[WHAT_TYPE_HANGER] = "어떤 종류의 행거가 사용되었습니까?";
translations[WHAT_WAS_HANGER_LENGTH] = "행거 길이 및 제조업체는 어디인가요?";
translations[WHICH_BAG_LOWER] = "어떤 백이 더 낮은곳에 걸렸나요?";
translations[WHAT_Y_SITE_WAS] = "보조 세트로 연결된 Y 사이트는 무엇인가요?";
translations[WHAT_COMPONENT_WITHIN] = "세트 내에서 용액이나 혈액을 제거할 수 없는 구성 요소는 무엇입니까?";
translations[WAS_COMPONENT_SET_REPLACED] = "구성 요소/세트를 세척 할 수 없는 상태로 교체했습니까?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "환자에게 주입했어야 할 처방된 액체의 부피와 시간은 어떻게 되나요?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "환자에게 실제로 주입된 액체의 부피와 시간은 어떻게 되나요?";
translations[WAS_USED_WITH_PUMP] = "그 세트가 펌프와 함께 사용되었나요?";
translations[DID_CLAMP_FAIL] = "클램프가 흐름을 멈추거나 제어하지 못했습니까?";
translations[WHAT_CLAMP_FAILED] = "어떤 클램프가 문제입니까?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "클램프에 문제가 있었습니까?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "이러한 다른 상황 중 제품 문제를 설명하는 경우가 있습니까(해당되는 모든 상황을 선택하십시오).";
translations[DESCRIBE_ALARM_OBSERVED] = "확인된 알람을 설명합니다.";
translations[INCLUDE_ANY_MESSAGES] = "알람과 관련된 메시지 및 오류 코드를 포함해주세요";
translations[WHICH_CLAMP_HAD_ISSUE] = "어느 클램프에 문제가 있었습니까?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "어떤 유형의 클램프 문제가 발생했습니까(해당되는 모든 항목을 선택)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "문제를 가장 잘 설명하는 시나리오를 선택하십시오.";
translations[PROVIDE_MORE_DETAILS] = "제품 사용의 어려움을 자세히 설명합니다.";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "준수/이해하기 어려운 지침에 대한 자세한 내용을 제공합니다.";
translations[DESCRIBE_THE_SMELL] = "냄새와 발생 위치에 대해 설명하십시오.";
translations[WAS_ISSUES_WITH_SET] = "세트에 문제가 있었습니까?";
translations[WHERE_LEAK_LOCATED] = "제품의 어디에 누출이 발생했습니까?";
translations[DID_OCCUR_WITH_LEAK] = "누출과 관련하여 다음 중 하나가 발생했습니까?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "분리된 두 번째 제품의 제품 정보 제공";
translations[DID_OCCURRED_WITH_THE_LEAK] = "누출과 관련하여 다음 시나리오 중 하나가 발생했습니까?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "제품이 어디가 손상되었습니까?";
translations[SELECT_ALL_APPLY] = "해당되는 항목을 모두 선택하십시오.";
translations[DESCRIBE_OBSERVED_DAMAGE] = "관찰된 손상을 설명해 주세요";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "제품의 어떤 구성 요소가 변색되었습니까?";
translations[DESCRIBE_HUE_TINT_SHADE] = "관찰된 색(색조, 음영 등)을 설명합니다.";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "내부 또는 외부 오버파우치, 온도, 빛 노출 등";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "입자상 물질/이물질의 정확한 위치, 크기, 형태 및 색상 설명:";
translations[DOES_THE_PARTICULATE_MATTER] = "미립자 물질/이물질이 제품 구성요소의 물질로 보이나요?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "미립자 물질/이물질이 고착되었습니까?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "미립자 물질/이물질이 제품을 구성하는 물질의 조각으로 보이나요?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "제품 어디에서 문제가 발생했나요?";
translations[LIST_COMPONENTS_IF] = "구성 요소를 나열합니다. 두 번째 제품이 관련된 경우, 제조업체, 제품명, 제품 코드, 제품 로트를 제공합니다.";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "눈에 보이는 불규칙성/손상이 관찰되었습니까?";
translations[SELECT_OPTION_FLOW_ISSUE] = "흐름 문제를 가장 잘 설명하는 옵션을 선택하십시오.";
translations[DESCRIBE_IRREGULARITIES] = "불규칙성/손상에 대해 설명해 주시고 연결/분리 전에 손상이 관찰되었는지 또는 연결/분리 중에 발생하였는지도 설명해 주세요.";
translations[HOW_PRODUCT_SETUP] = "제품 설정은 어땠습니까?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "라벨링 문제에 대한 가장 적절한 설명을 선택하십시오.";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "라벨에 부정확하거나 불완전하거나 누락되었거나 읽을 수 없는 것 또는 라벨이너무 유사한 것(다른 제품과)에 대해 설명하십시오.";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "배송 상자 안에 있는 제품이 파손되었나요?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "어떤 제품을 받기로 되어 있었습니까?";
translations[IF_PRODUCT_CODE_NOT] = "제품 코드를 알 수 없는 경우 제품 설명을 자세히 설명해 주세요";
translations[WAS_THE_CASE_MISSING] = "드라이아이스 또는 냉장 젤 팩이 없었습니까?";
translations[WHAT_CARRIER_DELIVERED] = "어떤 운송회사가 당신의 제품을 배달했나요?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "주문번호가 어떻게 되나요?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "누락된 유닛의 수량이 얼마나 됩니까?";
translations[WAS_EXPIRED_PRODUCT_USE] = "유효기간이 지난 제품이 사용되었나요?";
translations[APPLY_TO_EACH_UNIT] = "이 문제가 두 개 이상의 장치에서 발생한 경우 아래 질문은 각 장치에 적용됩니다.";
translations[TERMS_CONDITIONS] = "계약 조건";
translations[PRIVACY_POLICY] = "개인 정보 보호 정책";
translations[PRIVACY_NOTICE] = "개인 정보 보호 고지";
translations[COOKIE_POLICY] = "쿠키 정책";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "질문되었지만 알 수 없음";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Vantive 직원";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "간병인";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "대리점";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "의료 전문가";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "환자";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "기타";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "사용 후";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "사용 전";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "설정/준비/조제 중";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "치료 중";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "여러 단계";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "특정하지 않음";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "가족 구성원";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "간호사";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "임상 간호사";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "기타 의료 전문가";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "의사";
translations[OPTION_UNITOPTIONS_BOXES] = "상자";
translations[OPTION_UNITOPTIONS_PALLETS] = "팔레트";
translations[OPTION_UNITOPTIONS_UNITS] = "유닛";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "알람 조건";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "손상";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "사용하기 어려움";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "변색";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "흐름 문제";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "라벨링 문제";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "누출/과도한 수분";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "미립자 물질/이물질";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "환자 반응 / 부작용";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "제품 문의";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "분리/연결";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "배송 문제/유효기간 만료 제품";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "여자";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "미분화 된";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "남자";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "답변을 거부";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "관리자/감독자";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "바이오메디컬 엔지니어";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "회사 대표";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "치과 의사";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "대리점";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "가족 구성원";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "일반 사용자";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "간호사";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "임상 간호사";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "기타 의료 전문가";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "약사";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "약국 기술자";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "의사";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "환자";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "리스크 관리자";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "기타";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "추가적으로 다른 사람에게 연락주세요";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "저에게 연락주세요";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "기타 다른 사람에게 연락주세요";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "중국 FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (일본)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (호주)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "애완동물이나 동물이 문제를 일으켰을 가능성이 있다.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "날카로운 물체나 도구를 사용하여 상자 또는 오버파우치를 개봉했다.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "문제가 발생하기 전에 제품이 과도한 힘(즉, 부딪힘)에 노출되었습니다.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "제품이 고온/저온 환경에 노출되거나 보관되었습니다.";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "박스";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "미니캡";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "파우치";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "트랜스퍼 세트가 너무 빡빡했습니다.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "트랜스퍼 세트가 너무 느슨했습니다.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "트랜스퍼 세트를 완전히 잠글 수 없습니다.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "트랜스퍼 세트를 완전히 열 수 없습니다.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "트위스트 클램프가 너무 꽉 끼어서 트랜스퍼 세트가 전혀 열리지 않았습니다.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "트위스트 클램프가 너무 꽉 끼어서 트랜스퍼 세트가 전혀 닫히지 않았습니다.";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "예 - 전송 세트 나사산이 손상되어 올바르게 잠궈지지 않습니다.";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "예 - 미니 캡을 손으로 또는 공구/보조 장치로 트랜스퍼 세트에 과도하게 조였습니다.";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "액체가 흐르지 않고 완전히 멈췄습니다.";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "제한되거나 부분적으로 흐릅니다(느린 흐름)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "응고된 혈액";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "섬유소";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "구부러짐";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "미립자";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "제품 구성 물질";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "연결 시 또는 포장 내부에서 확인된 초과 요오드(갈색)";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "포장에서 확인된 과도한 수분(맑은 물방울)";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "제품을 열기 전에 발견된 손상된 파우치";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "사용하기 전에 패키지/박스가 열리거나 손상됨";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "말라서 하얗게 된 스펀지";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "갈색빛으로 말라버린 스펀지";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "보조 포장/오버 파우치 내부";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "제품/유체 경로 내부";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "배송 상자 내부";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "제품 외부 표면";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "보조 포장/오버파우치 외부";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "배송 상자 겉면";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "제품을 다른 제품과 연결하는 데 어려움이 있습니다.";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "다른 제품에서 제품을 분리하는 데 어려움이 있음";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "단일 제품의 구성 요소 분리";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "다른 제품과의 제품 분리";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "예 - 나사산에 잔류물";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "예 - 눈에 보이는 손상";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "예 - 기타(자유 텍스트)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "행거 구멍";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "주입/충전 포트";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "멤브레인 포트";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "오버파우치/파우치";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "패치";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "고무 스토퍼";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "배송 상자";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "수축밴드";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "솔루션 컨테이너";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "팁 프로텍터";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Tamper-evident sea(수축 랩)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "구부러진";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "깨진";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "금이간";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "베인";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "변형된";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "벗겨진";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "구멍";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "꼬인";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "녹은";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "패치 계층 분리";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "산산조각난(유리)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "잘린";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "찢어진";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "솔루션이 전혀 흐르지 않음";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "솔루션이 매우 느리게 흐름";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "재구성 또는 혼합 중에 용액이 흐르지 않음(또는 느리게 흐름)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "병";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "컨테이너";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "행거 구멍";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "라이너";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "오버파우치/파우치";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "산소 지표";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "패치";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "포트";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "솔루션";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "팁 프로텍터";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "아미노산 챔버";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "덱스트로즈 챔버";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "지질챔버";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "햐부 챔버";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "상부 챔버";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "터짐/파손된 씰";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "잘못 조립된 제품/부품";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "누락된 구성 요소";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "접합 구성 요소의 분리";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "제품 과다 주입";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "제품 과소 주입";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "재구성 문제";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "보조 포장/오버 파우치 내";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "배송 상자 내부";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "배송 상자 외부";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "용액/유체 경로 내부";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "기화기 섬프 내부(사이트 글라스)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "제품 외부 표면";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "보조 포장/오버파우치 외부";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "산소 흡수기 위";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Transdermal patch";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "유리 입자";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "포트";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "고무마개";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "튜빙";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "다른 약물을 추가한 후 또는 재구성 후(바이알)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "스파이크 또는 재구성 전";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "냉간(해동되었지만 아직 실온이 아님)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "냉동된";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "부분적으로 해동(용액에 얼음 결정)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "실온";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Vantive 해동 유닛(VTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "실온에 놓아두기";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "냉장고";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "예 - 배송 중에 손상된 흔적이 있음";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "예 - 누출이 관찰됨";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "예 - 오버 파우치에 구멍 또는 불완전한 씰이 발견됨.";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "예 - 스파이크 또는 재구성에 어려움이 있음";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "예 - frangible 부분을 깨는 데 어려움이 있음";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "예 - 용액의 결정화 또는 침전이 있음";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "예 - Frozen Galaxy 제품에 탁함/침전 현상이 있음";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "제품이 의도된 효과를 제공하지 않거나 효과적이지 않음(효과 부족)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "의도하지 않은 효과/반응. 구체적으로 명시해 주세요. (자유 텍스트)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "배송 중 상자 손상";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "유효기간 만료된 제품 배송";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "유효기간 만료된 제품 발견";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "바코드 문제 - 스캔 시 잘못된 정보가 표시됨";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "바코드 스캔/스캔 불가 문제";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "유효기간 만료된 제품 수령";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "재고에서 유효기간 만료된 제품 발견";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "읽을 수 없는 라벨";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "잘못된 라벨";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "불완전한 라벨";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "라벨이 다른 제품과 너무 유사함";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "라벨(제품, 상자, 배송 목록)에 동일한 제품 정보가 없음";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "바코드 누락";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "상자에 잘못된 제품 또는 혼합 제품이 들어 있음";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "배송 중 상자 손상";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "추가 수량이 들어있음";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "유효기간 만료된 제품 배송";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "유효기간 만료된 제품을 발견";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "상자의 일부가 열렸거나 밀봉되지 않음";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "상자 및 유통 라벨의 제품 정보가 상자 안의 제품과 일치하지 않음";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "제품이 누락됨";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "라벨 누락";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "만료 날짜";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "로트 번호";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "NDC 번호";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "누출이 관찰되지 않은 오버파우치 내부의 물방울/수분";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "누출";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "백을 압착할 때 누출이 관찰됨";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Frangible을 통과하여 흐르는 솔루션";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "누출이 관찰되지 않은 오버파우치 내부 용액";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "오버파우치와 기본 컨테이너 사이";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "두 제품 간의 연결";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "용기 - 멤브레인 포트/튜브";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "용기 - 주입/충전 포트";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "용기 - 행거 구멍";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "컨테이너";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "고무 스토퍼";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "수축밴드";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "팁 프로텍터";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "바이알 어댑터";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "부착 포트";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "보조 포장재 또는 중간 상자의 손상(구멍, 찢어짐)";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "극한 고온/저온 노출";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "기화기 인터페이스 누출";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "박스 커터/날카로운 물체로 포장 상자 열기";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "애완동물(발톱/무는 것)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "압력커프 또는 기타 장치로 눌린 용액 백";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "부착 포트";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "보조 포장재 또는 중간 상자의 손상(구멍, 찢어짐)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "배송 중 상자 손상";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "극한 고온/저온 노출";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "기화기 인터페이스 누출";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "박스 커터/날카로운 물체로 포장 상자 열기";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "애완동물(발톱/무는 것)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "압력커프 또는 기타 장치로 눌린 용액 백";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "위의 항목 중 아무 것도 아니다";
translations[NO_DESCRIBE_THE_COLOR] = "아니요 - 색상 설명(자유 텍스트)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "10mL 이상";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "1mL 미만";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "병";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "캡";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "밸브/neck";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "없음";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "제품을 다른 제품과 연결하는 데 어려움이 있습니다.";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "다른 제품에서 제품을 분리하는 데 어려움이 있음";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "단일 제품의 구성 요소 분리";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "다른 제품과의 제품 분리";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "드립 챔버";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "튜빙";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "기타 - (자유 텍스트)";
translations[OTHER_PLEASE_SPECIFY] = "기타 - (자유 텍스트)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "흰색/탁함";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "노란색/갈색";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "기타 - (자유 텍스트)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "1차 포장/파우치 내부";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "IV 유체 경로 내부(튜브 내부)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "배송 상자 내부";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "배송 상자 외부";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "IV 유체 경로 외부(튜브 외부)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "고착됨";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "느슨함";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "해당없음";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "색상 설명(자유 텍스트)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "예 - 변색";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "예 - 침전물";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "액세스 사이트";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "뷰렛";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "클램프";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "드립 챔버";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "튜빙";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "알수없음";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "필터";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "루어 커넥터";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "스파이크";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "절단/균열/파손된 구성 요소";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "잘못된 구성 요소 조립 - (자유 텍스트)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "꼬인 구성 요소";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "포장 내부의 느슨한 구성 요소";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "잘못된 형태의 구성 요소/잘못된 모양";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "누락된 구성 요소";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "제품을 다른 제품에 연결하는 데 어려움이 있음";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "다른 제품에서 제품 연결을 끊는 데 어려움이 있음";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "느슨한 연결";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "다른 제품과의 분리";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "단일 제품에서 접합된 두 구성 요소 사이의 분리";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "두 제품을 함께 연결할 수 없음";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "다른 제품에서 제품의 연결을 끊을 수 없음";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "바코드 문제 - 스캔 시 잘못된 정보가 표시됨";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "라벨 변경";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "바코드 스캔 어려움/스캔 불가 문제";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "만료된 제품";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "라벨의 잘못된 정보";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "바코드/UDI 누락";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "라벨에 정보가 누락됨";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "유효기간 없는 제품";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "지저분한/읽을 수 없는 라벨 표시";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "상자에 잘못된 제품 또는 혼합 제품이 들어 있습니다.";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "배송 중 상자 손상";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "유효기간 만료된 제품 배송";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "유효기간 만료된 제품을 발견";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "대리점";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "추가 제품이 수령";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "상자의 일부가 열렸거나 봉합되지 않았습니다.";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "상자 및 유통 라벨의 제품 정보가 상자 안의 제품과 일치하지 않습니다.";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "제품 수량이 부족";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "액세스 사이트";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "공기 투입구";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "뷰렛";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "캡";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "클리어링크 주입 부위 ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "클램프";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "드립 챔버";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "필터";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "인터링크 주입 부위";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "루어 커넥터";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "스파이크";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "튜빙";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "주입 부위와 튜브 사이의 누출";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "바늘 주입 부위";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "원링크 주입 부위";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "기타 주입 부위(자유 텍스트)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "견고한 세트 구성 요소의 균열/파손";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "튜브의 절단";
translations[DISCONNECTION_OF_CONNECTABLE] = "연결 가능한 구성 요소/연결된 제품의 분리";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "연결 가능한 구성 요소/연결된 제품의 분리";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "접합된 구성요소의 분리";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "예 - 불규칙성/손상 설명(자유 텍스트)";
translations[YES_SPECIFY_THE_TOOL] = "예 - 사용한 도구를 명시합니다(자유 텍스트)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "역류";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "클램프 고장 - 클램프하기 어려움(그러나 결국 닫을 수 있음)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "클램프 고장 - 완전히 차단할 수 없음";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "클램프 고장 - 열기 어려움/열 수 없음";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "흐름 없음";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "과다 주입";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "제한된/느린 흐름";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "동시 흐름";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "구성 요소 세척 불가";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "프라이밍 불가";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "주입 중";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "환자의 혈액(혈액제제가 주입되지 않음)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "솔루션/혈액 제제";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "누출 손상/구멍";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "연결 해제";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "누출";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "가압 주입을 통해 약물 투여 중 주사기 또는 IV 펌프";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "보조 백이 기본 백보다 낮았음";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "보조 백은 기본 백과 같은 높이였음";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "혈액 응고";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "세트에 부착하기 전에 카테터를 수평으로 맞출 수 없음";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "뒤틀린 튜브";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "튜브/주입 부위 막힘";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "기본 및 보조 컨테이너(Piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "다중 리드 세트에서 흐르는 두 개 이상의 리드";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "각각 자체 주입 펌프가 있는 2개의 투여 세트";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Vantive 행거";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "다른 회사의 행거";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "백은 같은 높이였음";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "기본백";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "보조백";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "가운데";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "더 낮게";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "위쪽의";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "예 - 펌프의 이름 및 제품 코드 제공(자유 텍스트)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "짙은 파란색 슬라이드 클램프";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "연한 파랑의 슬라이드 클램프";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "노치 클램프";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "롤러 클램프";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "흰색 슬라이드 클램프";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "예 - 클램프가 파손되었거나 균열이 있음";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "라인안의 공기";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "클램프 문제";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "냄새";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "노치/핀치 클램프";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "롤러 클램프";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "슬라이드 클램프";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "균열/파손";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "열기 어려움";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "닫기 어려움";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "누락";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "열 수 없음";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "닫을 수 없음";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "흐름을 제어할 수 없음";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "드립 챔버를 압착하기 어려움";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "지침을 따르기가/이해하기가 어려움";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "제품을 사용하기 어려움";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "균열/파손";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "긁힘/잘림";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "연결 가능한 구성 요소/연결된 제품의 분리";
translations[DISCONNECTION_OF_CONNECTABLE] = "연결 가능한 구성 요소/연결된 제품의 분리";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "구멍/찢어짐";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "접합부품의 분리";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "부착 포트";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "보조 포장재 또는 중간 상자의 손상(구멍, 찢어짐)";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "배송 중 상자 손상";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "극한 고온/저온 노출";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "박스 커터/날카로운 물체로 포장 상자 열기";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "위의 항목 중 아무 것도 아니다";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "압력 커프 또는 압력 인젝터가 사용됨";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "부착 포트";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "애완동물(발톱/물림)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "제품";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "배송용 상자";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "제품 내부";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "배송 상자 내부";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "제품 겉면";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "제품을 다른 제품에 연결하는 데 문제가 있음";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "다른 제품에서 제품을 분리하는 데 어려움이 있음";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "느슨한 연결";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "단일 제품의 구성 요소 분리";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "다른 제품과의 제품 분리";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "배송 상자의 외부";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "2차 포장/오버파우치 내부";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "2차 포장/오버파우치 외부";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "흐르지 않음";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "제한되거나 부분적으로 흐름";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "바코드 문제 - 스캔 시 잘못된 정보가 표시됨";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "바코드 스캔/스캔 불가 문제";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "읽을 수 없는 라벨";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "잘못된 라벨";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "불완전한 라벨";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "라벨(제품, 상자, 배송 목록)에 동일한 제품 정보가 없음";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "라벨이 다른 제품과 너무 유사함";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "라벨 누락";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "바코드 누락";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "냉동제품이 수령됨";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "해동된 제품이 수령됨";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "예, 알람이 울렸으나 어떤 알람인지 모릅니다.";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "예, 구체적으로 명시";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "예 - 트랜스퍼 세트를 완전히 열 수 없습니다.";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "예 - 트랜스퍼 세트를 완전히 잠글 수 없습니다.";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "예 - 트위스트 클램프가 너무 꽉 끼어서 트랜스퍼 세트가 전혀 열리지 않았습니다.";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "예 - 트위스트 클램프가 너무 꽉 끼어서 트랜스퍼 세트가 전혀 닫히지 않았습니다.";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "상자 또는 오버파우치";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "마지막 채우기 선의 파란색 클램프";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "카세트";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "배수 라인 커넥터 및 풀링 캡";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "배수 샘플 사이트";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "라인";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "루어/스파이크 커넥터";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "환자 라인의 풀링 캡/팁 프로텍터";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "풀링 캡/팁 프로텍터";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "히터 라인의 빨간색 클램프";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "압접 용접";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "공급 라인의 흰색 클램프";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "베이지 카테터 어댑터 커넥터";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "칩 인서트";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "진한 파랑 커넥터";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "연한 파랑 본체";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "하늘색 풀링 캡";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "연청색 오클루더 레그";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "실리콘 튜브";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "티타늄 스파이크";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV 플래시 스파이크";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "흰색 트위스트 클램프/슬리브";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "예: 손상 설명(자유 텍스트)";
translations[OPTION_MONTHOPTIONS_JAN] = "1월";
translations[OPTION_MONTHOPTIONS_FEB] = "2월";
translations[OPTION_MONTHOPTIONS_MAR] = "3월";
translations[OPTION_MONTHOPTIONS_APR] = "4월";
translations[OPTION_MONTHOPTIONS_MAY] = "5월";
translations[OPTION_MONTHOPTIONS_JUN] = "6월";
translations[OPTION_MONTHOPTIONS_JUL] = "7월";
translations[OPTION_MONTHOPTIONS_AUG] = "8월";
translations[OPTION_MONTHOPTIONS_SEP] = "9월";
translations[OPTION_MONTHOPTIONS_OCT] = "10월";
translations[OPTION_MONTHOPTIONS_NOV] = "11월";
translations[OPTION_MONTHOPTIONS_DEC] = "12월";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "기타";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "기타";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "기타(자유 텍스트)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "위의 항목 중 아무 것도 아니다";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "아니오";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "네";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "아니오";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "네";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "아니오";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "네";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "아니오";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "네";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "질문되었지만 알 수 없음";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "아니오";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "알수없음";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "네";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "아니오";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "네";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "아니오";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "네";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "아니오";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "네";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "아니오";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "네";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "아니오";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "네";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "아니오";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "네";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "아니오";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "네";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "아니오";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "네";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "아니오";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "네";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "아니오";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "네";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "아니오";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "네";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "아니오";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "네";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "아니오";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "네";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "아니오";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "아니오";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "네";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "아니오";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "네";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "아니오";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "네";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "아니오";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "네";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "아니오";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "네";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "아니오";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "네";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "아니오";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "네";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "아니오";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "네";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "아니오";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "네";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "아니오";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "네";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "아니오";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "아니오";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "네";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "아니오";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "네";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "아니오";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "네";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "아니오";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "알수없음";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "네";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "아니오";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "네";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "아니오";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "네";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "아니오";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "네";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "아니오";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "네";
translations[OPTION_vaporizerSightGlassOptions_NO] = "아니오";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "알수없음";
translations[OPTION_vaporizerSightGlassOptions_YES] = "네";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "아니오";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "네";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "아니오";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "네";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "아니오";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "네";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "아니오";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "네";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "아니오";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "네";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "아니오";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "네";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "아니오";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "네";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "아니오";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "네";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "아니오";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "네";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "아니오";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "알수없음";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "네";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "아니오";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "네";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "아니오";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "네";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "아니오";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "네";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "아니오";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "네";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "아니오";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "네";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "아니오";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "네";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "아니오";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "네";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "아니오";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "네";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "아니오";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "네";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "네";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "아니오";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "네";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "아니오";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "네";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "아니오";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "네";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "아니오";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "네";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "아니오";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "네";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "아니오";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "네";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "아니오";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "네";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "아니오";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "네";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "아니오";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "네";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "아니오";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "네";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "아니요";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "아니오";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "네";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "아니요";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "아니오";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "네";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "아니오";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "네";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "아니오";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "네";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "아니오";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "네";
translations[OPTION_WITHPUMPOPTIONS_NO] = "아니요";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "아니오";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "네";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "아니요";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "아니오";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "네";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "아니오";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "네";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "아니오";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "네";
translations[OPTION_GELPACKSOPTIONS_NO] = "아니오";
translations[OPTION_GELPACKSOPTIONS_YES] = "네";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "아니오";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "네";
translations[OPTION_ALARMOPTIONS_NO] = "아니요";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "아니오";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "네";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "아니오";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "아니오";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "네";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "아니오";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "네";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "아니오";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "알수없음";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "아니오";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "네";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "기타(자유 텍스트)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "아니오";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "네";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "아니오";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "네";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "아니오";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "네";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "질문되었지만 알 수 없음";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "질문되었지만 알 수 없음";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "아니요";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "위의 항목 중 아무 것도 아니다";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "아니요 - 색상 설명(자유 텍스트)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "예 - 사용한 도구를 명시합니다(자유 텍스트)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "분리";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "없음";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "예 - 기타(자유 텍스트)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "아니요";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "킬로그램";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "파운드";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "아니요";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "알수없음";
translations[PLEASE_ENTER_THE_VALUE] = "값을 입력하십시오";
translations[PLEASE_SELECT_THE_VALUE] = "값을 선택하십시오.";
translations[PLEASE_SELECT_THE_DATE] = "날짜를 선택하십시오.";
translations[PLEASE_CHOOSE_THE_VALUE] = "값을 선택하십시오";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "알수없음";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "영국";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "코소보";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "북아일랜드";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "아프가니스탄";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "올란드 제도";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "알바니아";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "알제리";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "미국령 사모아";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "안도라";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "앙골라";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "앙귈라";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "남극대륙";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "앤티가 바부다";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "아르헨티나";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "아르메니아";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "아루바";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "호주";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "오스트리아";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "아제르바이잔";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "바하마";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "바레인";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "방글라데시";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "바베이도스";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "벨로루시";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "벨기에";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "벨리즈";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "베냉";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "버뮤다";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "부탄";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "볼리비아";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "보스니아 헤르체코비나";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "보츠와나";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "부베 섬";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "브라질";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "영국령 인도양 식민지";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "브루나이";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "불가리아";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "부르키나 파소";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "부룬디";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "캄보디아";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "카메룬";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "캐나다";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "카보베르데";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "케이맨 제도";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "중앙아프리카 공화국";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "차드";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "칠레";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "중국";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "크리스마스 섬";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "코코스 제도";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "콜롬비아";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "코모로";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "콩고";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "콩고 민주 공화국";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "쿡 제도";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "코스타리카";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "코트디부아르";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "크로아티아";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "쿠바";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "키프로스";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "체코 공화국";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "덴마크";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "지부티";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "도미니카";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "도미니카 공화국";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "에콰도르";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "이집트";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "엘살바도르";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "적도 기니";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "에리트레아";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "에스토니아";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "에티오피아";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "포클랜드 제도";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "페로 제도";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "피지";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "핀란드";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "프랑스";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "프랑스령 기아나";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "프랑스령 폴리네시아";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "프랑스 남부령";
translations[OPTION_COUNTRYOPTIONS_GABON] = "가봉";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "감비아";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "그루지야";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "독일어";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "가나";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "지브롤터";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "그리스";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "그린란드";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "그레나다";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "과들루프";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "괌";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "과테말라";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "건지";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "기니";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "기니비사우";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "가이아나";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "아이티";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "허드 섬과 맥도날드 섬";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "교황청(바티칸 시)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "온두라스";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "홍콩";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "헝가리";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "아이슬란드";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "인도";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "인도네시아";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "이란";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "이라크";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "아일랜드";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "맨섬";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "이스라엘";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "이탈리아";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "자메이카";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "일본";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "저지";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "요르단";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "카자흐스탄";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "케냐";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "키리바시";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "북한";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "한국";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "쿠웨이트";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "키르기스스탄";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "라오스";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "라트비아";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "레바논";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "레소토";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "라이베리아";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "리비아";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "리히텐슈타인";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "리투아니아";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "룩셈부르크";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "마카오";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "마케도니아";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "마다가스카르";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "말라위";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "말레이시아";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "몰디브";
translations[OPTION_COUNTRYOPTIONS_MALI] = "말리";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "몰타";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "마샬 군도";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "마르티니크";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "모리타니아";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "모리셔스";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "마요트";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "멕시코";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "미크로네시아 연방";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "몰도바";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "모나코";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "몽골";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "몬테네그로";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "몬트세라트";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "모로코";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "모잠비크";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "미얀마";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "나미비아";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "나우루";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "네팔";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "네덜란드";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "뉴칼레도니아";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "뉴질랜드";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "니카라과";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "니제르";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "나이지리아";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "니우에";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "노퍽 섬";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "북마리아나 제도";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "노르웨이";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "오만";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "파키스탄";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "팔라우";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "팔레스타인";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "파나마";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "파푸아뉴기니";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "파라과이";
translations[OPTION_COUNTRYOPTIONS_PERU] = "페루";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "필리핀";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "핏케언";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "폴란드";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "포르투갈";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "푸에르토리코";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "카타르";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "레위니옹";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "루마니아";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "러시아 연방";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "르완다";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "생바르텔레미";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "세인트헬레나";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "세인트키츠네비스";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "세인트루시아";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "세인트마틴";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "생피에르 미클롱";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "세인트빈센트그레나딘";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "사모아";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "산마리노";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "상투메 프린시페";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "사우디 아라비아";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "세네갈";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "세르비아";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "세이셸";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "시에라리온";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "싱가폴";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "슬로바키아";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "슬로베니아";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "솔로몬 제도";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "소말리아";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "남아프리카 공화국";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "사우스조지아 사우스샌드위치 제도";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "스페인";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "스리랑카";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "수단";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "수리남";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "스발바르 얀마옌 제도";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "스와질란드";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "스웨덴";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "스위스";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "시리아";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "타이완";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "타지키스탄";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "탄자니아";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "태국어";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "동티모르";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "토고";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "토켈라우";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "통가";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "트리니다드토바고";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "튀니지";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "터키";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "투르크메니스탄 ";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "터크스 케이커스 제도";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "투발루";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "우간다";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "우크라이나";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "아랍에미리트";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "영국";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "미국";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "미국령 군소 제도";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "우루과이";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "우즈베키스탄";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "바누아투";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "베네수엘라";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "베트남";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "영국령 버진아일랜드";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "미국령 버진아일랜드";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "왈리스에푸투나";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "서사하라";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "예멘";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "잠비아";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "짐바브웨";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "아니오";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "알수없음";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "네";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Vantive 제품 피드백 포털에 대한 링크된 개인정보 보호정책을 읽고 이해했습니다.";
translations[PRODUCT_LOT] = "제품 제조번호";
translations[SHIPPING_DISTRIBUTION_LABEL] = "배송/유통 라벨";
translations[CARTON_LABEL] = "판지 라벨";
translations[INTERNAL_PRODUCT_LABEL] = "내부 제품 라벨";
translations[TITLE_PD_RENAL] = "PD 신장";
translations[TITLE_SOLUTIONS] = "솔루션";
translations[TITLE_ACCESS] = "입장";
translations[TITLE_ALL_OTHER_PRODUCT] = "기타 모든 제품";
translations[REPORTED_PROBLEM] = "보고된 문제";
translations[LOGIN] = "로그인";
translations[SYSTEM_MENU] = "시스템 메뉴";
translations[INITIATE_PRODUCT_FEEDBACK] = "제품 피드백 시작";
translations[FEEDBACK_STATUS] = "피드백 상태";
translations[OKTACALLBACK] = "Okta콜백";
translations[VALID_EMAIL] = "올바른 이메일 주소를 입력하십시오.";
translations[VALID_NUMERIC] = "숫자 전체를 입력합니다.";
translations[PLEASE_UPLOAD_IMAGE] = "이미지를 업로드 해주세요";
translations[VALID_DATE] = "유효한 날짜를 선택하세요.";
translations[QUANTITY] = "수량";
translations[EDIT] = "편집하다";
translations[DELETE] = "삭제";
translations[LOT_SERIAL_NO] = "로트/일련 번호";
translations[LOT_NUMBER_NOT_FOUND] = "로트 번호를 찾을 수 없습니다.";
translations[SEARCHING_LOT_NUMBER] = "로트 번호 검색";
translations[PRODUCT_CODE_NOT_FOUND] = "제품 코드를 찾을 수 없습니다.";
translations[SEARCHING_PRODUCT_CODE] = "제품 코드 검색";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "파일 형식(.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps)은 허용되지 않습니다.";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "첨부하려는 파일이 저장소 제한을 초과합니다. 파일을 압축하거나 다른 파일을 첨부하십시오.";
translations[IMAGE_ICON] = "이미지 아이콘을 클릭하여 옵션을 선택합니다.";
translations[LOGIN_TO_ACCOUNT] = "계정에 로그인";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "계정에 로그인";
translations[PASSWORD] = "비밀번호";
translations[SIGN_IN] = "로그인";
translations[UNKNOWN] = "알수없음";
translations[ASKED_UNKNOWN] = "질문되었지만 알 수 없음";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "국가 선택";
translations[CHINESE_SIMPLIFIED_CHINESE] = "중국어(간체 중국어)";
translations[DUTCH] = "네덜란드어";
translations[ENGLISH] = "영어";
translations[FRENCH] = "프랑스어";
translations[GERMAN] = "독일어";
translations[ITALIAN] = "이탈리아어";
translations[JAPANESE] = "일본어";
translations[KOREAN] = "한국어";
translations[MANDARIN_TRADITIONAL_CHINESE] = "표준 중국어";
translations[POLISH] = "폴란드어";
translations[PORTUGUESE] = "포르투갈어";
translations[SPANISH] = "스페인어";
translations[THAI] = "태국어";
translations[TURKISH] = "터키어";
translations[VIETNAMESE] = "네덜란드어";
translations[BROWSE] = "검색";
translations[FEEDBACK_SUBMITTED] = "피드백 제출됨";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "제품 피드백이 성공적으로 제출되었습니다. 보고해 주셔서 감사합니다. 당신은 참조 번호가 포함된 이메일을 받게 됩니다. 의료 제품 공급업체로서, 우리 제품에 대한 고객 만족과 피드백은 최고 품질의 제품을 제공한다는 우리의 목표에 필수적입니다. 연락주세요";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "질문이나 추가 정보가 있는 경우.";
translations[CLOSE] = "닫다";
translations[PATIENT_AGE] = "환자 나이 또";
translations[ENTER_AGE] = "나이 입력";
translations[PATIENT_DOB] = "환자 나생년월일";
translations[RELEVANT_ATTACHMENTS] = "관련 첨부 파일을 제공하십시오.";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Vantive 계정 자격 증명을 입력하십시오.";
translations[GET_PRODUCT_DETAILS] = "제품 세부 정보 얻기";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "위의 다이어그램(그림 2)을 사용하여 보고된 문제의 위치를 ​​확인합니다.";
translations[FACILITY_ADDRESS] = "시설 주소";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "다른 시설 주소";
translations[CHOOSE_PRODUCT_CODE] = "입력한 로트/일련 번호에 대한 제품 코드를 선택하십시오.";
translations[DECLINE] = "거절";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "보네르, 신트 유스타티우스, 사바";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "퀴라소";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "남 수단";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "에스와티니";
translations[FORM_HELP_TEXT] = "이 필드에 대한 도움말 텍스트를 사용할 수 있음을 나타냅니다.";
translations[YOUR_FIRST_NAME] = "당신의 이름";
translations[YOUR_LAST_NAME] = "당신의 성";
translations[MY_FIRST_NAME] = "본인 이름";
translations[MY_LAST_NAME] = "본인 성";
translations[PATIENT_FIRST_NAME] = "환자 이름";
translations[PATIENT_LAST_NAME] = "환자의 성";
translations[REPORTER_FIRST_NAME] = "최초 보고자 이름";
translations[REPORTER_LAST_NAME] = "보고자의 성";
translations[EMPLOYEE_FIRST_NAME] = "직원 이름";
translations[EMPLOYEE_LAST_NAME] = "직원 성";
translations[END_USER_CUSTOMER_FIRST_NAME] = "최종 사용자/고객 이름";
translations[END_USER_CUSTOMER_LAST_NAME] = "최종 사용자/고객 성";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "추가 연락처 이름";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "추가 연락처 성";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "All rights reserved | Version";
translations[ADD_ADDITIONAL_CONTACT] = "추가 연락처";
translations[CONTACT_ME] = "고객이 연락을 원하지 않습니다. 추가 질문이 있으면 저에게 연락하십시오.";
translations[DO_NOT_CONTACT] = "연락하지 마세요";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "최종 사용자/고객 시설 이름";
translations[END_USER_CUSTOMER_PHONE] = "최종 사용자/고객 시설 전화번호";
translations[END_USER_CUSTOMER_EMAIL] = "최종 사용자/고객 이메일 주소";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "최종 사용자/고객 시설 주소";
translations[SAME_AS_PATIENT_ADDRESS] = "환자 주소와 동일";
translations[SAME_AS_REPORTER_ADDRESS] = "기자 주소와 동일";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "최종 사용자/고객 시설 주소와 동일";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "위의 다이어그램(그림 3)을 사용하여 보고된 문제의 위치를 확인합니다.";
translations[CONTACT_US] = "문의하기";
translations[LANDING_BRIEF_FOR_DEVICE] = "장치(장비)수리, 부품, 서비스 또는 기술 지원이 필요하신 경우는 기술 서비스 지원팀에 문의해 주십시오.";
translations[PATIENT_SEX] = "환자의 섹스";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "시스젠더 남자/소년";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "시스젠더 여성/소녀";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "트랜스젠더 남성/트랜스 남성/여성에서 남성으로";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "트랜스젠더 여성/트랜스 여성/남성에서 여성으로";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "기타 성별 카테고리; 명시 해주세요";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "답변을 거부";
translations[ATTENTION_NEEDED] = "!!!긴급 주의 사항: 제품 피드백 포털 제출이 실패했습니다!";
translations[SUBMIT_ERR_MSG] = "다시 제출하려면 확인을 클릭한 다음 제출을 클릭하십시오. 또는 (@@@)에게 불만 사항을 이메일로 보내십시오.";
translations[SUBMIT_RETRY_MSG] = "다시 제출한 경우 제품 피드백 포털로부터 이메일 상자에 확인 이메일을 받았는지 확인하십시오.확인 이메일을 받지 못했다면 제출에 실패한 것이므로 반드시 (@@@)에게 불만 사항을 이메일로 보내야 합니다.";
translations[OK] = "OK";

export default lang;